import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import toastConfig from 'components/configuration/toast-config';
import { errorMessage } from 'components/common/helper-function/catchErrorMessage';
import { smsgateway } from 'services/applicationSettingService'
import { checkModulePermission } from 'components/common/helper-function/ModulePermissionCheck';
import { loaderContext } from 'context/Context';

function SMSSettings() {
    const [smsData, setSmsData] = useState()
    const { t } = useTranslation();
    const { isLoading, setIsLoading } = useContext(loaderContext)
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        clearErrors,
        formState: { errors }
    } = useForm();


    useEffect(async () => {
        checkModulePermission("SMS Settings")
        setIsLoading(true)
        try {
            const { data } = await smsgateway({ is_update: 0 })
            setSmsData(data?.data[0])
            reset(data?.data[0])
        } catch (e) {
            errorMessage(e)
        }
        setIsLoading(false)
    }, [])

    const onSubmit = async (formData) => {
        setIsLoading(true)
        try {
            const { data } = await smsgateway({ is_update: 1, ...formData })
            console.log("data=====>", data)
            toast.success(data?.message, toastConfig);
        } catch (e) {
            if (e.response.data) {
                if (Array.isArray(e.response.data.message)) {
                    e.response.data.message.map(errors => toast.error(errors, toastConfig))
                } else {
                    toast.error(e.response.data.message, toastConfig)
                }
            } else {
                toast.error(e.message, toastConfig)
            }
        }
        setIsLoading(false)
    };
    const onReset = () => {
        setValue("gateway_key", "")
        setValue("gateway_secret_key", "")
        setValue("url", "")
        setValue("sender_id", "")
        clearErrors()
    };
    return (
        <>
            <div className="mb-3 row g-3">
                <div className="card overflow-hidden mb-3">
                    <div className="card-header">
                        <div className="row">
                            <div className="col-12">
                                <h3 className="heading-color fw-600">
                                    {t('smsSettings.heading.smsSettings')}
                                </h3>
                            </div>
                            <div className="col-12 mb-3">
                                <hr />
                            </div>
                            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                                <div className='row'>
                                    <div className="form-group col-md-3 mb-3">
                                        <label className="form-label">
                                            {t('smsSettings.label.senderid')}
                                            <span className="text-danger ms-1">*</span>
                                        </label>
                                        <input
                                            className={`form-control ${errors.sender_id ? 'is-invalid' : ''
                                                }`}
                                            type="text"
                                            placeholder={t('smsSettings.placeholder.senderid')}
                                            {...register('sender_id', {
                                                required: true
                                            })}
                                        />
                                        {errors.sender_id && (
                                            <small className="text-danger">
                                                {errors.sender_id.type === 'required' && (
                                                    <span>{t('smsSettings.error.senderError')}</span>
                                                )}
                                            </small>
                                        )}
                                    </div>

                                    <div className="form-group col-md-3 mb-3">
                                        <label className="form-label">
                                            {t('smsSettings.label.apikey')}
                                            <span className="text-danger ms-1">*</span>
                                        </label>
                                        <input
                                            className={`form-control ${errors.gateway_key ? 'is-invalid' : ''
                                                }`}
                                            type="text"
                                            placeholder={t('smsSettings.placeholder.apikey')}
                                            {...register('gateway_key', {
                                                required: true
                                            })}
                                        />
                                        {errors.gateway_key && (
                                            <small className="text-danger">
                                                {errors.gateway_key.type === 'required' && (
                                                    <span>{t('smsSettings.error.apikey')}</span>
                                                )}
                                            </small>
                                        )}
                                    </div>

                                    <div className="form-group col-md-3 mb-3">
                                        <label className="form-label">
                                            {t('smsSettings.label.secretKey')}
                                            <span className="text-danger ms-1">*</span>
                                        </label>
                                        <input
                                            className={`form-control ${errors.gateway_secret_key ? 'is-invalid' : ''
                                                }`}
                                            type="text"
                                            placeholder={t('smsSettings.placeholder.secretKey')}
                                            {...register('gateway_secret_key', {
                                                required: true
                                            })}
                                        />
                                        {errors.gateway_secret_key && (
                                            <small className="text-danger">
                                                {errors.gateway_secret_key.type === 'required' && (
                                                    <span>{t('smsSettings.error.secretKeyError')}</span>
                                                )}
                                            </small>
                                        )}
                                    </div>
                                    <div className="form-group col-md-3 mb-3">
                                        <label className="form-label">
                                            {t('smsSettings.label.url')}
                                            <span className="text-danger ms-1">*</span>
                                        </label>
                                        <input
                                            className={`form-control ${errors.url ? 'is-invalid' : ''
                                                }`}
                                            type="text"
                                            placeholder={t('smsSettings.placeholder.url')}
                                            {...register('url', {
                                                required: true
                                            })}
                                        />
                                        {errors.url && (
                                            <small className="text-danger">
                                                {errors.url.type === 'required' && (
                                                    <span>{t('smsSettings.error.urlError')}</span>
                                                )}
                                            </small>
                                        )}
                                    </div>
                                </div>
                                <div className="mb-3 mt-3 text-end">
                                    <button type="submit" className="btn btn-primary me-1">
                                        {t('smsSettings.btnLabel.add')}
                                    </button>
                                    <button
                                        type='button'
                                        className="btn btn-danger"
                                        onClick={() => onReset()}
                                    >
                                        {t('smsSettings.btnLabel.reset')}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SMSSettings